import { QuizBoard } from "@/modes/quiz/QuizBoard";
import { WheelBoard } from "@/modes/wheel/WheelBoard";
import { WheelSettings, WheelStudent, WheelTeacher } from "@/modes/wheel/WheelViews";

const BoardView = ({ state, remaining, send }) => (state.phase === "wheel" ? <WheelBoard state={state} send={send} /> : <QuizBoard state={state} remaining={remaining} send={send} />);

const wheel = {
  key: "wheel",
  label: "Çarkıfelek",
  SettingsForm: WheelSettings,
  StudentView: WheelStudent,
  BoardView,
  TeacherView: WheelTeacher,
};

export default wheel;
